export default __webpack_public_path__ + "static/media/Ellipse.64b6edad.svg";